import { render, staticRenderFns } from "./StatusInspec.vue?vue&type=template&id=8af9d842"
import script from "./StatusInspec.vue?vue&type=script&lang=js"
export * from "./StatusInspec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports